export class NumeroWhatsapp {
  id: number;
  whatsapp: string;
  principal: boolean;
  ocultar: boolean;
  removido: boolean;
  usadoParaCampanhas?: boolean;
  versaoExtensao: number = 3;
  limiteDiario: number;
  /** Informacoes calculadas pelo servidor a partir do limite e da janela. */
  intervaloEnvioSegundos: number;
  intervaloMinimoSegundos: number;
  limitePorHoraCalculado: number;
  intervaloCampanhaSegundos: number;
  intervaloAutomacaoSegundos: number;
  intervaloStatusPedidoSegundos: number;
  intervaloAvaliacaoSegundos: number;
  intervaloGlobalAutomaticoSegundos: number;
  limiteAutomacaoPorHora: number;
  limiteCampanhaPorHora: number;
  duracaoMinimaCampanhaHoras: number;
  capacidadeDiariaCalculada: number;
  duracaoDaJanelaHoras: number;
  janelaInicioHora: number;
  janelaFimHora: number;
  pausado: boolean;
  usadoHoje?: number;
  restanteHoje?: number;
  proximoEnvioEmMs?: number;
  incertasHoje?: number;
  politicaCarregada?: boolean;
  politicaErro?: boolean;
}
